import React from 'react';
import RideNowLogo from '../../assets/rideNowLogo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import {
  // solid,
  // regular,
  // brands,
  icon,
} from '@fortawesome/fontawesome-svg-core/import.macro'; // <-- import styles to be used

import './NavBar.css';

export const NavBar = () => {
  return (
    <div className="navbar-container">
      <div style={{ display: 'flex', margin: '0 2%', flex: 1 }}>
        <div>
          <img src={RideNowLogo} width={'200px'} height={'50px'} />
        </div>

        <div className="menu">
          <a href="https://www.ridenowauctions.com/">Home</a>

          <a href="https://ridenowauctions.com/auctions/catalog/id/5">
            Inventory
          </a>

          <a href="">About Us</a>
        </div>

        <div className="mobile-menu">
          <a href="https://www.ridenowauctions.com/">
            {/* <FontAwesomeIcon icon={icon({ name: 'home', style: 'solid' })} /> */}
            Home
          </a>

          <a href="https://ridenowauctions.com/auctions/catalog/id/5">
            {/* <FontAwesomeIcon icon={icon({ name: 'hammer', style: 'solid' })} /> */}
            Inventory
          </a>
        </div>

        <div className="login-container">
          {/* <span>SIGN IN</span>
          <span className="signup">SIGN UP</span> */}
        </div>
      </div>
    </div>
  );
};
